import { Info } from 'lucide-react'

import claudeIcon from '@/assets/claude-icon.png'
import { Badge } from '@/components/ui/badge'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

/**
 * Marks a section as part of the Cai Brand System — the subset mirrored in
 * Claude Design. There is no orange in the palette, so this uses the closest
 * light warm tone (fuel-yellow-200) with --amber-text, the token meant for text
 * on an amber-tinted surface.
 */
export function MarketingChip() {
  return (
    <Tooltip>
      {/* The whole chip is the trigger, not just the info icon. tabIndex makes
          it keyboard-reachable, since a Badge renders a non-focusable span. */}
      <TooltipTrigger asChild>
        <Badge tabIndex={0} className="bg-fuel-yellow-200 shrink-0 cursor-help gap-1.5 text-(--amber-text)">
          <img src={claudeIcon} alt="" className="size-3" />
          Marketing
          <Info className="opacity-70" />
        </Badge>
      </TooltipTrigger>
      <TooltipContent>This content is included in the Cai Brand System of Claude Design tool.</TooltipContent>
    </Tooltip>
  )
}
